import type { TableColumn } from '@indipia/ui-core'
import type { ListDisplayItem, NextAction } from '../../types/scheduleList.types'
import { STAGE_KIND_LABEL } from '../../types/scheduleList.types'
import { ScheduleListMilestoneRow } from './ScheduleListMilestoneRow'
import { ScheduleListNextActionCell } from './ScheduleListNextActionCell'
import { ScheduleListPeriodCell } from './ScheduleListPeriodCell'
import { ScheduleListStageCell } from './ScheduleListStageCell'
import { ScheduleListWorkTypeCell } from './ScheduleListWorkTypeCell'

// 행 틀(D-04·D-05·D-06) — 표 머리글·열 폭과 행 셀 연결. 공종 행은 6칸, 마일스톤 행은 첫 칸에만 내용을 둔다.
// 열 폭은 px 하드코딩 없이 %로 정한다(합계 96%, 나머지는 펼침 표시 열). 최소 폭은 표 쪽 minWidth 가 맡는다.

export interface ScheduleListColumnArgs {
  /** 다음 할 일 버튼을 보일 수 있는지(useScheduleListActions.canRunNextAction) */
  canRunNextAction: (action: NextAction | null) => boolean
  /** 다음 할 일 버튼 실행(useScheduleListActions.runNextAction) */
  onRunNextAction: (taskId: number, action: NextAction) => void
}

export function buildScheduleListColumns({ canRunNextAction, onRunNextAction }: ScheduleListColumnArgs): TableColumn<ListDisplayItem>[] {
  return [
    {
      key: 'workType', header: '공종 (선행)', align: 'left', width: '19%',
      render: it => it.kind === 'milestone'
        ? <ScheduleListMilestoneRow milestone={it.milestone} />
        : <ScheduleListWorkTypeCell row={it.row} />,
    },
    {
      key: 'period', header: '기간', align: 'left', width: '11%',
      render: it => it.kind === 'task' ? <ScheduleListPeriodCell period={it.row.period} /> : null,
    },
    {
      key: 'foreman', header: STAGE_KIND_LABEL.FOREMAN, align: 'left', width: '16%',
      render: it => it.kind === 'task' ? <ScheduleListStageCell cell={it.row.cells.foreman} /> : null,
    },
    {
      key: 'order', header: STAGE_KIND_LABEL.ORDER, align: 'left', width: '18%',
      render: it => it.kind === 'task' ? <ScheduleListStageCell cell={it.row.cells.order} /> : null,
    },
    {
      key: 'work', header: STAGE_KIND_LABEL.WORK, align: 'left', width: '16%',
      render: it => it.kind === 'task' ? <ScheduleListStageCell cell={it.row.cells.work} /> : null,
    },
    {
      key: 'next', header: '다음 할 일', align: 'left', width: 'calc(var(--num-160) + var(--spacing-02))',
      render: it => it.kind === 'task'
        ? (
            <ScheduleListNextActionCell
              action={it.row.nextAction}
              canRun={canRunNextAction(it.row.nextAction)}
              onRun={a => onRunNextAction(it.row.taskId, a)}
            />
          )
        : null,
    },
  ]
}
